import HttpErrorResponseModel from '../../models/HttpErrorResponseModel';
import IStore from '../../models/IStore';
import {ReduxDispatch} from '../../models/ReduxProps';
import * as ActionUtility from "../../utilities/ActionUtility";
import UserEffect from '../effects/userEffect';
import UserImportResponse from '../models/UserImportResponse';
import UserModel from '../models/UserModel';

type ActionUnion =
    void
    | HttpErrorResponseModel
    | UserModel
    | String
    | UserImportResponse;

export default class UserActions {

    public static readonly REQUEST_GET_USER_LIST = 'UserActions.REQUEST_GET_USER_LIST';
    public static readonly REQUEST_GET_USER_LIST_FINISHED = 'UserActions.REQUEST_GET_USER_LIST_FINISHED';

    public static readonly REQUEST_GET_USER_ADMIN_LIST = 'UserActions.REQUEST_GET_USER_ADMIN_LIST';
    public static readonly REQUEST_GET_USER_ADMIN_LIST_FINISHED = 'UserActions.REQUEST_GET_USER_ADMIN_LIST_FINISHED';

    public static readonly REQUEST_POST_USER = 'UserActions.REQUEST_POST_USER';
    public static readonly REQUEST_POST_USER_FINISHED = 'UserActions.REQUEST_POST_USER_FINISHED';

    public static readonly REQUEST_GET_USER = 'UserActions.REQUEST_GET_USER';
    public static readonly REQUEST_GET_USER_FINISHED = 'UserActions.REQUEST_GET_USER_FINISHED';

    public static readonly REQUEST_DELETE_USER = 'UserActions.REQUEST_DELETE_USER';
    public static readonly REQUEST_DELETE_USER_FINISHED = 'UserActions.REQUEST_DELETE_USER_FINISHED';

    public static readonly REQUEST_PUT_USER = 'UserActions.REQUEST_PUT_USER';
    public static readonly REQUEST_PUT_USER_FINISHED = 'UserActions.REQUEST_PUT_USER_FINISHED';

    public static readonly REQUEST_PUT_OWN_USER = 'UserActions.REQUEST_PUT_OWN_USER';
    public static readonly REQUEST_PUT_OWN_USER_FINISHED = 'UserActions.REQUEST_PUT_OWN_USER_FINISHED'; //not needed

    public static readonly REQUEST_EXPORT_USER_LIST = 'UserActions.REQUEST_EXPORT_USER_LIST';
    public static readonly REQUEST_EXPORT_USER_LIST_FINISHED = 'UserActions.REQUEST_EXPORT_USER_LIST_FINISHED';

    public static readonly REQUEST_IMPORT_USER_LIST = 'UserActions.REQUEST_IMPORT_USER_LIST';
    public static readonly REQUEST_IMPORT_USER_LIST_FINISHED = 'UserActions.REQUEST_IMPORT_USER_LIST_FINISHED';

    public static readonly REQUEST_CHECK_USER_INITIAL_SETUP = 'UserActions.REQUEST_CHECK_USER_INITIAL_SETUP';
    public static readonly REQUEST_CHECK_USER_INITIAL_SETUP_FINISHED = 'UserActions.REQUEST_CHECK_USER_INITIAL_SETUP_FINISHED';

    public static getUserList = (): any => {
        return async (dispatch: ReduxDispatch<ActionUnion>, getState: () => IStore) => {
            await ActionUtility.createThunkEffect<UserModel>(
                dispatch,
                getState(),
                UserActions.REQUEST_GET_USER_LIST,
                UserEffect.getUserList,
            );
        };
    };

    public static getUserAdminList = (): any => {
        return async (dispatch: ReduxDispatch<ActionUnion>, getState: () => IStore) => {
            await ActionUtility.createThunkEffect<UserModel>(
                dispatch,
                getState(),
                UserActions.REQUEST_GET_USER_ADMIN_LIST,
                UserEffect.getUserAdminList,
            );
        };
    };

    public static updateOwnUser = (idToken: string): any => {
        return async (dispatch: ReduxDispatch<ActionUnion>, getState: () => IStore) => {
            return ActionUtility.createThunkEffect(
                dispatch,
                getState(),
                UserActions.REQUEST_PUT_OWN_USER,
                UserEffect.updateOwnUser,
                idToken
            );
        };
    }

    public static createUser = (model: UserModel): any => {
        return async (dispatch: ReduxDispatch<ActionUnion>, getState: () => IStore) => {
            return ActionUtility.createThunkEffect(
                dispatch,
                getState(),
                UserActions.REQUEST_POST_USER,
                UserEffect.createUser,
                model
            );
        };
    };

    public static getUser = (userId: string) => {
        return async (dispatch: ReduxDispatch<ActionUnion>, getState: () => IStore) => {
            await ActionUtility.createThunkEffect<UserModel>(
                dispatch,
                getState(),
                UserActions.REQUEST_GET_USER,
                UserEffect.getUser,
                userId
            );
        };
    };

    public static deleteUser = (userId: string): any => {
        return async (dispatch: ReduxDispatch<ActionUnion>, getState: () => IStore) => {
            return ActionUtility.createThunkEffect(
                dispatch,
                getState(),
                UserActions.REQUEST_DELETE_USER,
                UserEffect.deleteUser,
                userId
            );
        };
    };

    public static putUser = (userId: string, model: any): any => {
        return async (dispatch: ReduxDispatch<ActionUnion>, getState: () => IStore) => {
            return ActionUtility.createThunkEffect(
                dispatch,
                getState(),
                UserActions.REQUEST_PUT_USER,
                UserEffect.updateUser,
                userId,
                model
            );
        };
    };

    public static exportUserList = (): any => {
        return async (dispatch: ReduxDispatch<ActionUnion>, getState: () => IStore) => {
            return ActionUtility.createThunkEffect(
                dispatch,
                getState(),
                UserActions.REQUEST_EXPORT_USER_LIST,
                UserEffect.exportUserList
            );
        };
    }

    public static importUserList = (csvFile: File): any => {
        return async (dispatch: ReduxDispatch<ActionUnion>, getState: () => IStore) => {
            return ActionUtility.createThunkEffect(
                dispatch,
                getState(),
                UserActions.REQUEST_IMPORT_USER_LIST,
                UserEffect.importUserList,
                csvFile
            );
        };
    }

    public static checkUserInitialSetup = (): any => {
        return async (dispatch: ReduxDispatch<ActionUnion>, getState: () => IStore) => {
            await ActionUtility.createThunkEffect<UserModel>(
                dispatch,
                getState(),
                UserActions.REQUEST_CHECK_USER_INITIAL_SETUP,
                UserEffect.checkUserInitialSetup,
            );
        };
    };
}